import { isMobile } from "..";
import { BASE_URL } from "../url";
import * as Sentry from "@sentry/react";

export const bannoTenants = {
    banno: "banno",
    tinker: "tinker",
    cornerstone: "cornerstone",
    trustar: "trustar",
    edmonton: "edmonton"
};

export const isBannoServiceProvider = (props, fromProps = true) => {
    if (!fromProps) {
        return Object.values(bannoTenants).includes(props);
    }
    return Object.values(bannoTenants).includes(props?.state?.theme?.values?.tenantFullName);
}

export const isBannoTenant = (props, fromProps = true) => {
    const bannoTenants = { banno: "banno" };
    if (!fromProps) {
        return Object.values(bannoTenants).includes(props);
    }
    return Object.values(bannoTenants).includes(props?.state?.theme?.values?.tenantFullName);
}

export const isTinkerTenant = (props, fromProps = true) => {
    const bannoTenants = { tinker: "tinker" };
    if (!fromProps) {
        return Object.values(bannoTenants).includes(props);
    }
    return Object.values(bannoTenants).includes(props?.state?.theme?.values?.tenantFullName);
}

export const isCornerstoneTenant = (props, fromProps = true) => {
    const bannoTenants = { cornerstone: "cornerstone" };
    if (!fromProps) {
        return Object.values(bannoTenants).includes(props);
    }
    return Object.values(bannoTenants).includes(props?.state?.theme?.values?.tenantFullName);
}

export const isTrustarTenant = (props, fromProps = true) => {
    const bannoTenants = { trustar: "trustar" };
    if (!fromProps) {
        return Object.values(bannoTenants).includes(props);
    }
    return Object.values(bannoTenants).includes(props?.state?.theme?.values?.tenantFullName);
}

export const isEdmontonTenant = (props, fromProps = true) => {
    const bannoTenants = { edmonton: "edmonton" };
    if (!fromProps) {
        return Object.values(bannoTenants).includes(props);
    }
    return Object.values(bannoTenants).includes(props?.state?.theme?.values?.tenantFullName);
}

export const getShortNameForEnrollment = (props, fromProps = true) => {

    if (isBannoTenant(props, fromProps)) {
        return ``
    } else if (isTinkerTenant(props, fromProps)) {
        return `TFCU`
    } else if (isCornerstoneTenant(props, fromProps)) {
        return `CCFCU`
    } else if (isTrustarTenant(props, fromProps)) {
        return `TRUSTAR`
    } else if (isEdmontonTenant(props, fromProps)) {
        return `EDMONTON`
    } else {
        return null;
    }
}

export const loadBannoBridge = (tenant) => {

    if (!isBannoServiceProvider(tenant, false)) {
        return;
    }

    const url = "https://cdn.jsdelivr.net/npm/@jack-henry/banno-plugin-framework-bridge@1.0.3/dist/banno-plugin-framework-bridge.js";

    // if already loaded, resolve immediately
    if (window && window.Bridge) {
        return Promise.resolve(window.Bridge);
    }
    // avoid loading multiple times: reuse existing promise
    if (window && window._bannoBridgeLoading) {
        return window._bannoBridgeLoading;
    }

    // dynamic import of an external module URL (must be supported by the browser)
    const promise = import(/* webpackIgnore: true */ url)
        .then(mod => {
            // store globally for other parts of the app
            window.Bridge = mod;
            if (typeof mod.enableRouter === "function") {
                try {
                    mod.enableRouter();
                    console.log("Banno router enabled (from dynamic loader).");
                    //alert(`Banno router enabled (from dynamic loader).`)
                } catch (err) {
                    console.error("Banno bridge loaded but enableRouter() threw:", err);
                    // Task #15380: report explicitly - the console is no longer forwarded to Sentry
                    Sentry.captureException(err, {
                        tags: { integration: "banno-bridge", step: "enableRouter", tenant },
                    });
                    //alert("Banno bridge loaded but enableRouter() threw:", err)
                }
            } else {
                console.error("Banno bridge loaded but enableRouter() not found.");
                Sentry.captureMessage("Banno bridge loaded but enableRouter() not found", {
                    level: "error",
                    tags: { integration: "banno-bridge", step: "enableRouter", tenant },
                });
                //alert("Banno bridge loaded but enableRouter() not found.")
            }
            return mod;
        })
        .catch(err => {
            console.error("Failed to load Banno bridge:", err);
            //alert("Failed to load Banno bridge:", err)
            // cleanup so future attempts can retry
            delete window._bannoBridgeLoading;
            throw err;
        });

    // cache the promise
    window._bannoBridgeLoading = promise;
    return promise;
}


export const hideEnrollmentBannoTenants = (props) => {
    if (isBannoServiceProvider(props) && window.parent.banno) {
        window.parent.banno.enrollment.ishow = false;
        window.parent.banno.updateEnroll(true);
    }
}

export const showEnrollmentBannoTenants = (props) => {
    if (isBannoServiceProvider(props) && window.parent.banno) {
        window.parent.banno.enrollment.ishow = true;
        window.parent.banno.updateEnroll(false);
    }
}

export const updateTokenBannoTenants = (props, token) => {
    if (isBannoServiceProvider(props) && window.parent.banno) {
        window.parent.banno.updateToken(token);
    }
}

export const setNotificationCount = (props, count) => {
    if (isBannoServiceProvider(props) && window.parent.banno) {
        window?.parent?.banno?.setNotificationCount(count);
    }
}

export const launchBannoIFrame = (props, fromProps = true) => {
    if (isBannoServiceProvider(props, fromProps)) {

        const tenantFullName = fromProps
            ? props?.state?.theme?.values?.tenantFullName
            : props; // props itself is the value

        const typeDashboard = `?type=dashboard` //OLD:: tenantFullName === "banno" ? `` : `?type=dashboard`;

        const url = `${BASE_URL.API}/integrations/banno/status/step-one/${tenantFullName}${typeDashboard}`;
        return url;
    }
}

export const launchBannoIFrameViaScript = (props, fromProps = true) => {
    if (!isBannoServiceProvider(props, fromProps)) return;

    const tenantFullName = fromProps
        ? props?.state?.theme?.values?.tenantFullName
        : props; // props itself is the value

    if (!tenantFullName) return;

    const typeDashboard = `?type=dashboard` //OLD:: tenantFullName === "banno" ? `` : `?type=dashboard`;

    window.Bridge.postUniversalMessage({
        type: "click-link",
        data: {
            href: `${BASE_URL.API}/integrations/banno/status/step-one/${tenantFullName}${typeDashboard}`,
            external: false
        }
    });
};

export const openExternalLink = (e, url) => {
    try {
        // prevent default navigation here
        if (e?.preventDefault) {
            e.preventDefault();
        }

        if (
            typeof window !== "undefined" &&
            window.Bridge &&
            typeof window.Bridge.postUniversalMessage === "function" &&
            isMobile()
        ) {
            window.Bridge.postUniversalMessage({
                type: "click-link",
                payload: {
                    href: url,
                    external: true
                }
            });
        } else {
            window.open(url, "_blank", "noopener,noreferrer");
        }
    } catch (err) {
        console.error("openExternalLink failed:", err);
        window.open(url, "_blank", "noopener,noreferrer");
    }
};